export interface SettingsFormData {
  GENESYS: {
    enabled: boolean;
  };
  CHRISTMAS: {
    enabled: boolean;
  };
  SIERRA_EMAIL_AI: {
    enabled: boolean;
  };
}

export const DEFAULT_SETTINGS: SettingsFormData = {
  GENESYS: {
    enabled: false,
  },
  CHRISTMAS: {
    enabled: false,
  },
  SIERRA_EMAIL_AI: {
    enabled: true,
  },
};
